import { Box, Stack, Typography, Divider, Avatar } from '@mui/material';


const LowerText = () => {
    return (
        <Box>

        <Stack spacing={3} p={4}>

            <Typography variant='h3'>

                 IP Address:
          
            </Typography>

            <Typography>

            An IP is your virtual address. Every device connected to the internet has an IP address attributed to it, which reveals its IP geolocation. Someone who looks up your IP address can see your location down to the street level. IP addresses help data to find its destination and reach the intended online recipient.

          
          </Typography>


          <Typography>

          If you can find out the IPv4 or IPv6 address of an Internet user, you can get an idea what part of the country or world they're in by using our IP Lookup tool.

          
          </Typography>

          <Typography>

                Want to find out the IP geolocation of your IP address? Our IP Address Lookup tool will show you the city, state, zip code, country, ISP, and time zone of any IP.

                </Typography>



          <Typography variant='h4'>
             What you will get with this IP tool lookup:  
          
          </Typography>

          <Typography component="ul">
        
          
                <li>The ISP and organization's name</li>
                <li>The IP's hostname</li>
                <li>The country it's in</li>
                <li>The region/state</li>
                <li>The city </li>
                <li>The area code for that region</li>
                <li>ip location</li>
                <li>ip address tracker</li>
                <li>ip address tracker online</li>
                <li>free ip address lookup</li>
                <li>google ip address locator</li>
            
           
          </Typography>

        </Stack>
    </Box>
    );
}

export default LowerText;